import React from "react";
import { Link } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import { ROUTES } from "../../constants/routes";
import { selectCartCount, useCartStore } from "../../store/cartStore";
import { scrollToTop } from "../../utils/scroll";

function CartNavLink({ className = "" }) {
  const count = useCartStore(selectCartCount);

  return (
    <Link
      to={ROUTES.cart}
      onClick={scrollToTop}
      className={`caf-cart-nav ${className}`}
      aria-label={`Cart${count ? `, ${count} items` : ""}`}
    >
      <FaShoppingCart className="caf-cart-nav__icon" aria-hidden="true" />
      {count > 0 ? (
        <span className="caf-cart-nav__badge">{count > 99 ? "99+" : count}</span>
      ) : null}
    </Link>
  );
}

export default CartNavLink;
